import "../../shared/academy-typography.css";
import "./styles/fixed-navigation.css";
import "./styles/contained-controls.css";
import React from "react";
import App from "./App";
import { mountFrontend } from "./app/bootstrap";
import { APP_ID } from "./config/environment";
import { AppErrorBoundary } from "./components/AppErrorBoundary";
import "./styles/auth-magic.css";
import "./styles/account-fit.css";
import "./styles/verify-email.css";
import "./styles/application-fit.css";
import { safeLoadState } from "./data/mockData";
import { readAuthorizationClientId } from "./services/authorization";
import { accountJourneyScreen } from "./services/accessRoutes";
import { roleById } from "./utils/auth";

const root = document.getElementById("root");

if (!root) {
  throw new Error("Unable to find the root element");
}

const runSessionCheck = () => {
  const state = safeLoadState();
  const roleId = state.onboarding.roleId || state.application.roleId;
  const role = roleById(roleId);
  const clientId = readAuthorizationClientId();
  const message = {
    source: "chatoner-academy-session-check",
    authenticated: Boolean(state.authenticated),
    completed: accountJourneyScreen(state) === "complete",
    roleId,
    roleCategory: role.category,
    clientId,
  };
  try {
    window.parent.postMessage(message, "*");
  } catch {
    /* posting to the host page may be unavailable */
  }
  root.removeAttribute("aria-busy");
  const fallback = document.createElement("div");
  fallback.dataset.sessionCheck = "true";
  root.append(fallback);
};

if (window.location.pathname.replace(/\/+$/, "") === "/session-check") {
  runSessionCheck();
} else {
  void mountFrontend(
    root,
    <React.StrictMode>
      <AppErrorBoundary>
        <App />
      </AppErrorBoundary>
    </React.StrictMode>,
    APP_ID,
  );
}
